import { styled } from "@phntms/css-components";
import styles from "./styles.module.scss";


export const PageContainer = styled('div', {
  css: styles.pageContainer,
  variants: {
    isMenuOpened: {
      true: styles.menuOpened
    },
    addBottomPadding: {
      true: styles.paddingBottom
    },
  }
})

export const Content = styled('div', {
  css: styles.content,
  variants: {

  }
})




export const PageWrapper = styled('div', {
  css: styles.pageWrapper,
  variants: {
    variants: {
      isMenuOpened: {
        true: styles.menuOpened
      }
    }
  }
})


